var exports = {
  "N": "HiddenHeading__U48D4M",
};

module.exports = exports;
